export function isOpaque(deluge, props) {
  const { hideicons, hide_activate_controls, myKey } = props;
  if (deluge?.pinned_svars?.['1']?.['General']?.[myKey]?.auto) {
    return true;
  }
  if (hide_activate_controls) {
    return true;
  }
  return false;
}
